import React from "react";
import { useRef } from "react";
import { useEffect, useState } from "react";
import {ContentUtils}  from "../utils/ContentUtils";

function Content({vertical, kind, postId, content, featuredImage}) {

  const thisComponentRef = useRef();

  const [contentCleaned, setContentCleaned] = useState('');

  useEffect(

    () => {
      // TODO: spostare qui tutta la pulizia replace di url o cdn etc etc di content
      // TODO: replace dei domini
      if(content !== '') {
        setContentCleaned(
          ContentUtils.clean_content(
            content, featuredImage && featuredImage.node ? featuredImage.node : ""
          )
        );
      }
      else {
        setContentCleaned('');
      }

      setTimeout(function() {
        ContentUtils.hbsptFormsCreate(contentCleaned);
      }, 1000);

      var elements = document.querySelectorAll(`#${vertical}-${kind}-${postId}-content a`);

      [].forEach.call(elements, function(element) {
          var new_url = element.href;

          if(!new_url.includes('startupitalia.eu') && !new_url.includes('localhost:')) {
            console.log(new_url);
            element.setAttribute('target', '_blank');
          }
      });

    },
    [content, thisComponentRef, setContentCleaned, contentCleaned, featuredImage]
  );

  return (
    <div
      ref={thisComponentRef}
      style={{ fontSize: "21px" }}
      id={`${vertical}-${kind}-${postId}-content`}
      className={`${vertical}-${kind}-content`}
    >
      <div
        id="entry-content"
        className="entry-content content-component"
        dangerouslySetInnerHTML={{ __html: contentCleaned }}
      />
    </div>
  );
}


export default Content;
